const phoneSystemHistoryPrefix = 'nwx-phone-system-history';

export const PhoneSystemHistoryTrackingIds = {
  table: {
    globalTrackingId: `${phoneSystemHistoryPrefix}-table`, // Will be applied to the table pagination components
    nameTextLink: `${phoneSystemHistoryPrefix}-table-name-text-link`,
    detailsTextLink: `${phoneSystemHistoryPrefix}-table-details-text-link`,
    rowSearchButton: `${phoneSystemHistoryPrefix}-table-row-search-button`,
    objectIdColumnInfoIcon: `${phoneSystemHistoryPrefix}-table-object-id-column-info-icon`,
    updatedByTextLink: `${phoneSystemHistoryPrefix}-table-updated-by-text-link`,
  },
  tableFilters: {
    dateRangeDropdown: `${phoneSystemHistoryPrefix}-table-filters-date-range-dropdown`,
    dateRangeApplyButton: `${phoneSystemHistoryPrefix}-table-filters-date-range-apply-button`,
    dateRangeClearButton: `${phoneSystemHistoryPrefix}-table-filters-date-range-clear-button`,
    settingTypeDropdown: `${phoneSystemHistoryPrefix}-table-filters-setting-type-dropdown`,
    actionDropdown: `${phoneSystemHistoryPrefix}-table-filters-action-dropdown`,
    clearAllFiltersButton: `${phoneSystemHistoryPrefix}-table-filters-clear-all-filters-button`,
    userDropdown: `${phoneSystemHistoryPrefix}-table-filters-user-dropdown`,
    userApplyButton: `${phoneSystemHistoryPrefix}-table-filters-user-apply-button`,
    userClearButton: `${phoneSystemHistoryPrefix}-table-filters-user-clear-button`,
    userWeaveSystemCheckbox: `${phoneSystemHistoryPrefix}-table-filters-user-weave-system-checkbox`,
    userWeaveTeamCheckbox: `${phoneSystemHistoryPrefix}-table-filters-user-weave-team-checkbox`,
    userOfficeStaffCheckbox: `${phoneSystemHistoryPrefix}-table-filters-user-office-staff-checkbox`,
  },
  detailsTray: {
    xIconCloseButton: `${phoneSystemHistoryPrefix}-details-tray-x-icon-close-button`,
    eventCardDrawerExpandButton: `${phoneSystemHistoryPrefix}-details-tray-event-card-expand-button`,
    eventCardDrawerCollapseButton: `${phoneSystemHistoryPrefix}-details-tray-event-card-collapse-button`,
  },
  seeHistoryButtons: {
    phoneSettingsMain: `${phoneSystemHistoryPrefix}-phone-settings-main`,
    callBlocking: `${phoneSystemHistoryPrefix}-call-blocking`,
    callRecording: `${phoneSystemHistoryPrefix}-call-recording`,
    holdMusic: `${phoneSystemHistoryPrefix}-hold-music`,
  },
};
